import { forgotPassword } from '../../../modules/account/api';

export const forgotPasswordUseCase = (email: string): Promise<void> => {
  return forgotPassword(email);
};